var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collaborators__panel-body" },
    [
      _c("div", { staticClass: "collaborators-width" }, [
        _c(
          "div",
          { staticClass: "collaborators__title" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.collaboratorsTitle) + " ")]),
            _c(
              "v-btn",
              {
                staticClass: "primary-button uppercase",
                attrs: { small: "", disabled: !_vm.buttonAddColaborator },
                on: {
                  click: function($event) {
                    _vm.openNewItem()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.buttonNewCollaborator))]
            )
          ],
          1
        )
      ]),
      _vm._l(_vm.listOfTeam, function(boss, index) {
        return _c("ListItem", {
          key: boss.id,
          attrs: {
            team: boss,
            index: boss.value,
            typeOfTable: { typeOfTable: _vm.typeOfTable },
            withSearchBox: true,
            withCompleteTableFields: true,
            completeFields: true
          },
          on: { editSellerTable: _vm.editSellerTable }
        })
      }),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.conditionalNotContent,
              expression: "conditionalNotContent"
            }
          ],
          staticStyle: { "text-align": "center" }
        },
        [_vm._v(_vm._s(_vm.messageNotContent))]
      ),
      _c("newSellerModal", {
        ref: "newSellerModal",
        on: {
          completeForm: _vm.completeForm,
          upDateListBoss: _vm.upDateListBoss
        }
      }),
      _c("alertModal", { ref: "alertModal" }),
      _c("loader", { ref: "loaderModal", attrs: { text: _vm.loaderText } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d89325e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d89325e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/my-team/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d89325e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/my-team/index.vue
// module chunks = 7